import React, { Component } from "react";
import "./style.less";

export default class Content extends Component {
	constructor(props) {
		super(props);

		this.state = {
			height: 0,
		};
	}

	componentDidMount() {
		const height = document.querySelector('#cp-nav-bar').offsetHeight;
		this.setState({ height });
	}

	render() {
		return (
			<main className="content" style={{marginTop: this.state.height}}>
				{this.props.children}
			</main>
		);
	}
}
